import { useDispatch, useSelector } from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import { Element } from '../../../../../common/html/element'
import { PopupAction } from '../../../../../common/popup/PopupAction'
import { TranslateAddCompany } from '../../../../common/html/text/TranslateCompany'
import { changeFragment } from '../../../portfoliosOverview/store/slice/sliceComponent'
import {
  clearAllCompany,
  selectDataHeaderPortfolioDetail,
} from '../../store/slice'
import {
  getHeaderSavedPortfolioDetail,
  postAddNewCompany,
} from '../../store/thunk'

export const ConfirmApply = ({
  isShow,
  setShow,
  count,
  setShowPopupAddCompany,
  setNonePopup,
  ids,
  clearFunction,
}) => {
  const dispatch = useDispatch()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const { portfolioName } = useSelector(selectDataHeaderPortfolioDetail)

  const handleConfirm = () => {
    dispatch(
      postAddNewCompany({
        portfolioIds: [parseInt(id)],
        organizationIds: ids,
      }),
    )
      .unwrap()
      .then(() => {
        dispatch(clearAllCompany())
        dispatch(changeFragment())
        dispatch(getHeaderSavedPortfolioDetail({ portfolioId: id }))
        setNonePopup(false)
        clearFunction && clearFunction()
      })
      .catch(() => {
        setShowPopupAddCompany(true)
        setShow(false)
      })
  }

  const handleCancel = () => {
    setShowPopupAddCompany(true)
    setShow(false)
  }

  return (
    <>
      <PopupAction
        title="library.detailsPortfolios.CONFIRMATION"
        isShow={isShow}
        handleClose={handleCancel}
        btnSubmit={{
          label: 'library.filterSetting.APPLY',
          isI18n: true,
          event: handleConfirm,
        }}
        btnCancel={{
          label: 'library.filterSetting.CANCEL',
          isI18n: true,
          event: handleCancel,
        }}
      >
        <Element
          elementName="p"
          style={{
            fonSize: 12,
            overflowWrap: 'break-word',
          }}
        >
          <TranslateAddCompany name={portfolioName} count={count} />
        </Element>
      </PopupAction>
    </>
  )
}
